import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PageHeader } from 'src/app/models/common/page-header';
import { BaseSearchComponent } from 'src/app/system-common/base-search/base-search.component';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { AgentService } from '../services/agent.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { FieldItem } from 'src/app/models/common/field-item';
import { SearchResponseIO } from 'src/app/models/search-responseIO';
import { BaseComponent } from 'src/app/system-common/base/base.component';

@Component({
  selector: '',
  template: '',
})
export class AgentBankBranchHandler extends BaseComponent<AgentService> implements OnInit {
  @Input() public service: any;
  @Input() public model: any;
  public searchName: string;
  public searchCriteriaData = {
    // ' AgentMasterDO.agentId': null,
    // 'AgentMasterDO.agentName': null,
    'AgentMasterDO.branchId': null,
    'AgentMasterDO.channelCd': null,
    // 'AgentMasterDO.intermedCatCd': null,
    'AgentMasterDO.parentAgencyId': null,
  };
  public item: any;
  public isifscCdSearchDisplayed: boolean;
  public parentAgentIdSelectedOption: any;
  protected parentAgentIdFieldItems: FieldItem[];
  isSearchListDisplayed: boolean;
  isAgentNameSelected: boolean;
  public displaySearchforField = 'ifscCd';

  constructor(public agentService: AgentService, public router: Router, public settingService: SettingService) {
    super(agentService);
    this.searchName = 'SearchBankBranch';
    this.isSearchListDisplayed = false;
    this.isAgentNameSelected = false;
  }

  ngOnInit() {
    this.service.find(false).subscribe(
      (searchList) => {
        let list = JSON.parse(JSON.stringify(searchList));
        this.service.searchResponseIO = new SearchResponseIO();
        this.service.searchResponseIO = list;

        console.log('Get search list successful.');
      },
      (error) => {
        console.log('Get search list failed.');
        console.log('Error:', error);
      }
    );
  }

  protected getMoreOptionList(): any[] {
    return [];
  }

  protected getPageHeader(): PageHeader {
    let header = new PageHeader();
    header.title = 'Search - Bank Branch';
    return header;
  }

  public onparentAgentIdSearchClick(field: FieldItem) {
    this.isifscCdSearchDisplayed = true;
    console.log(this.model);

    setTimeout(() => {
      let id = this.model == undefined ? field.model.guid : this.model.guid;
      this.openModal('ifscCdSearch' + id);
    }, 20);
  }

  public onparentAgentIdSearchSelected(selectedOption) {
    console.log('this.model', this.model);

    this.parentAgentIdSelectedOption = selectedOption;
    this.service.setModelFieldValue(this.model, 'ifscCd', selectedOption['ifscCd']);
    this.service.setModelFieldValue(this.model, 'bankName', selectedOption['bankName']);
    // this.service.setModelFieldValue(this.model, 'agentName', selectedOption['agentName']);
    this.service.setModelFieldValue(this.model, 'branchName', selectedOption['branchName']);
  }

  public onparentAgentIdFieldsCreated(fieldItemArray: FieldItem[]) {
    if (this.parentAgentIdFieldItems != undefined) {
      fieldItemArray.filter((item) => {
        let index = this.parentAgentIdFieldItems.findIndex((field: FieldItem) => field.fieldCd == item.fieldCd);
        let isAvailable = this.parentAgentIdFieldItems.find((field: FieldItem) => field.fieldCd == item.fieldCd);
        if (!isAvailable) this.parentAgentIdFieldItems.push(item);
        if (isAvailable) this.parentAgentIdFieldItems[index] = item;
      });
    } else {
      this.parentAgentIdFieldItems = fieldItemArray;
    }
  }
}
